import { m } from 'framer-motion';
import PropTypes from 'prop-types';
import { Box, Container, Grid, LinearProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import useResponsive from 'src/hooks/useResponsive';
import { fPercent } from '../../utils/formatNumber';
import { MotionViewport, varFade } from 'src/components/animate';
import Image from 'next/image';

const RootStyle = styled('div')(({ theme }) => ({
    textAlign: 'center',
    paddingTop: theme.spacing(8),
    backgroundColor: theme.palette.grey[200],
    paddingBottom: theme.spacing(8)
}));

const AboutImage = styled(Image)(() => ({
    width: '100%',
    height: '100%',
    display: 'block'
}));

const AboutMobileImage = styled(Image)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'block',
    [theme.breakpoints.up('sm')]: {
        display: 'none',
    }
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '22px'
    }
}));

const CustomSubTypography = styled(Typography)(({ theme }) => ({
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '13px'
    }
}));

export default function HomeTrack() {

    const isDesktop = useResponsive('up', 'md');

    return (
        <RootStyle>
            <Container component={MotionViewport}>
                <Grid container spacing={4}>
                    {isDesktop ? (
                        <Grid item xs={6}>
                            <m.div variants={varFade().inUp}>
                                <AboutImage
                                    alt=""
                                    src="/images/home/track.png"
                                    width="500"
                                    height="300"
                                />
                            </m.div>
                        </Grid>
                    ) :
                        (
                            <Grid item xs={12}>
                                <AboutMobileImage
                                    alt=""
                                    src="images/home/track-mobile.png"
                                    width="500"
                                    height="300"
                                />
                            </Grid>
                        )
                    }

                    <Grid item xs={12} md={6} lg={5}>
                        <m.div variants={varFade().inRight}>
                            <CustomTypography variant="h3" sx={{ mb: 2 }}>
                                What is the Asset Track for Cloud (ATC)?
                            </CustomTypography>
                        </m.div>

                        <m.div variants={varFade().inRight}>
                            <CustomSubTypography
                                sx={{
                                    color: (theme) => (theme.palette.mode === 'light' ? 'text.secondary' : 'common.white'),
                                }}
                            >
                               A complete end-to-end asset management system that incorporates Bar Codes, QR inventory codes, GPS, RFID and cloud-based software to allow inventory management professionals to track and manage equipment or any asset, residential customers to manage their valuables, commercial and industrial clients to manage their buildings, maintenance and resources.
                            </CustomSubTypography>
                        </m.div>
                        {
                            <m.div variants={varFade().inRight}>
							  <Box sx={{ flexDirection: 'row', }}>
                                    <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>

                                        <Box>
                                            <a href="https://apps.apple.com/app/asset-track-for-cloud/id6444088217" target="_blank" rel="noreferrer">
                                                <Image
                                                    alt="apple_link"
                                                    src="/images/home/apple_badge.png"
                                                    height="50"
                                                    width="160"
                                                />
                                            </a>
                                        </Box>
                                        <Box ml={4}>
                                            <a href="https://play.google.com/store/apps/details?id=com.assettrackforcloud" target="_blank" rel="noreferrer">
                                                <Image
                                                    alt="google_link"
                                                    src="/images/home/google-play-badge.png"
                                                    height="50"
                                                    width="160"
                                                />
                                            </a>
                                        </Box>
                                    </Box>
                                </Box>
                            {/* <CustomButton
                                variant="outlined"
                                color="primary"
                                size="large"
                                sx={{ mt: 2 }}
                            >
                                Register Now
                           </CustomButton>*/}
							</m.div>
                        
                        }
                    </Grid>
                </Grid>
            </Container>
        </RootStyle>
    );
}

// ----------------------------------------------------------------------

ProgressItem.propTypes = {
    progress: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.number,
    }),
};

function ProgressItem({ progress }) {
    const { label, value } = progress;

    return (
        <Box sx={{ mt: 3 }}>
            <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle2">{label}&nbsp;-&nbsp;</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {fPercent(value)}
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    '& .MuiLinearProgress-bar': { bgcolor: 'grey.700' },
                    '&.MuiLinearProgress-determinate': { bgcolor: 'divider' },
                }}
            />
        </Box>
    );
}
